/* ============================================================
   De Club van Sinterklaas — Shopify thema
   theme.js — winkelmand (AJAX), drawer, sterren, toast
   ============================================================ */
(function () {
  "use strict";
  var T = window.theme || {};
  var routes = T.routes || {};

  /* ---------- helpers ---------- */
  function money(cents) {
    var euro = (cents / 100).toFixed(2).replace(".", ",");
    return "€" + euro;
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- toast ---------- */
  var toastTimer = null;
  function toast(msg) {
    var t = $("#ShopToast");
    if (!t) { t = document.createElement("div"); t.className = "sh-toast"; t.id = "ShopToast"; document.body.appendChild(t); }
    t.textContent = msg;
    requestAnimationFrame(function () { t.classList.add("show"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2200);
  }
  window.shopToast = toast;

  /* ---------- cart drawer rendering ---------- */
  function badgeUpdate(count) {
    $all("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "" : "none";
    });
  }

  function renderDrawer(cart) {
    var itemsEl = $("#CartDrawerItems");
    var footEl = $("#CartDrawerFoot");
    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="sh-empty">Je winkelmand is nog leeg.<br>Tijd om cadeautjes te zoeken! 🎁</div>';
      if (footEl) footEl.style.display = "none";
    } else {
      itemsEl.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, "_120x$1$2") : "";
        var variant = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== "Default Title"; })
          .map(function (o) { return o.value; }).join(" / ");
        return '' +
          '<div class="sh-li" data-key="' + it.key + '">' +
            '<img class="sh-li-img" src="' + img + '" alt="" />' +
            '<div class="sh-li-main">' +
              '<p class="sh-li-t">' + it.product_title + '</p>' +
              (variant ? '<span class="sh-li-v">' + variant + '</span>' : '') +
              '<div class="sh-qty">' +
                '<button type="button" data-qty-down aria-label="Minder">−</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-qty-up aria-label="Meer">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="sh-li-r">' +
              '<span class="sh-li-p">' + money(it.final_line_price) + '</span>' +
              '<button type="button" class="sh-li-x" data-remove>verwijder</button>' +
            '</div>' +
          '</div>';
      }).join("");
      if (footEl) {
        footEl.style.display = "";
        var subEl = $("#CartDrawerSubtotal");
        if (subEl) subEl.textContent = money(cart.items_subtotal_price);
      }
    }

    badgeUpdate(cart.item_count);
  }

  function fetchCart() {
    return fetch(routes.cart + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function openDrawer() {
    var d = $("#CartDrawer"), o = $("#CartOverlay");
    if (d) d.classList.add("open");
    if (o) o.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }
  function closeDrawer() {
    var d = $("#CartDrawer"), o = $("#CartOverlay");
    if (d) d.classList.remove("open");
    if (o) o.classList.remove("open");
    document.documentElement.style.overflow = "";
  }
  window.cvsOpenCart = openDrawer;

  /* ---------- add to cart ---------- */
  function addToCart(id, quantity, btn) {
    var body = { id: id, quantity: quantity || 1 };
    return fetch(routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (item) {
      if (item.status) { toast(item.description || "Er ging iets mis"); return; }
      return fetchCart().then(function (cart) {
        renderDrawer(cart);
        toast("🎁 " + (item.product_title || "Toegevoegd") + " toegevoegd");
        if (T.cartDrawer) openDrawer();
        if (btn) {
          var orig = btn.textContent;
          btn.classList.add("added"); btn.textContent = "✓ Toegevoegd";
          setTimeout(function () { btn.classList.remove("added"); btn.textContent = orig; }, 1400);
        }
      });
    });
  }
  window.cvsAddToCart = addToCart;

  function changeLine(key, quantity) {
    return fetch(routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderDrawer(cart);
      // also refresh full cart page if present
      if (document.body.classList.contains("template-cart")) location.reload();
      return cart;
    });
  }

  /* ---------- event wiring ---------- */
  document.addEventListener("click", function (e) {
    // open cart
    var openBtn = e.target.closest("[data-cart-open]");
    if (openBtn) { e.preventDefault(); fetchCart().then(renderDrawer).then(openDrawer); return; }
    // close cart
    if (e.target.closest("[data-cart-close]") || e.target.id === "CartOverlay") { closeDrawer(); return; }

    // quick add (product card)
    var quick = e.target.closest("[data-quick-add]");
    if (quick) {
      e.preventDefault();
      var vid = quick.getAttribute("data-variant-id");
      if (!vid) { window.location = quick.getAttribute("data-url"); return; }
      addToCart(vid, 1, quick);
      return;
    }

    // drawer qty / remove
    var li = e.target.closest(".sh-li");
    if (li) {
      var key = li.getAttribute("data-key");
      var qtyEl = li.querySelector(".sh-qty span");
      var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.closest("[data-qty-up]")) { changeLine(key, cur + 1); return; }
      if (e.target.closest("[data-qty-down]")) { changeLine(key, Math.max(0, cur - 1)); return; }
      if (e.target.closest("[data-remove]")) { changeLine(key, 0); return; }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  /* ---------- product form (PDP) ---------- */
  function initProductForm() {
    var form = $("[data-product-form]");
    if (!form) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput || !idInput.value) { toast(T.strings.chooseOption); return; }
      addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1, form.querySelector("[data-add-btn]"));
    });

    // variant selection (size buttons / selects)
    var variantsData = $("#ProductVariantsJSON");
    if (!variantsData) return;
    var variants = JSON.parse(variantsData.textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = $("[data-product-price]");

    function currentOptions() {
      return $all("[data-option-index]", form).map(function (el) {
        if (el.type === "radio") { return null; } // handled per group below
        return el.value;
      });
    }
    function selectByOptions(opts) {
      var match = variants.find(function (v) {
        return opts.every(function (o, i) { return o == null || v.options[i] === o; });
      });
      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        var addBtn = form.querySelector("[data-add-btn]");
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? (addBtn.getAttribute("data-label") || "In winkelmand") : "Uitverkocht";
        }
      }
    }
    function gather() {
      var groups = {};
      $all("select[data-option-index], input[data-option-index]", form).forEach(function (el) {
        var idx = parseInt(el.getAttribute("data-option-index"), 10);
        if (el.type === "radio") { if (el.checked) groups[idx] = el.value; }
        else { groups[idx] = el.value; }
      });
      var arr = [];
      for (var i = 0; i < 3; i++) arr[i] = groups[i] != null ? groups[i] : null;
      selectByOptions(arr);
    }
    form.addEventListener("change", gather);
    $all("[data-size-btn]", form).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var grp = btn.getAttribute("data-option-index");
        $all('[data-size-btn][data-option-index="' + grp + '"]', form).forEach(function (b) { b.classList.remove("on"); });
        btn.classList.add("on");
        var hidden = form.querySelector('[data-option-hidden="' + grp + '"]');
        if (hidden) hidden.value = btn.getAttribute("data-value");
        gather();
      });
    });
    gather();

    // qty stepper
    $all("[data-qty-step]", form).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var input = form.querySelector('[name="quantity"]');
        var v = parseInt(input.value, 10) || 1;
        v += btn.getAttribute("data-qty-step") === "up" ? 1 : -1;
        input.value = Math.max(1, v);
      });
    });
  }

  /* ---------- thumbnail gallery (PDP) ---------- */
  function initGallery() {
    var main = $("[data-gallery-main]");
    if (!main) return;
    $all("[data-gallery-thumb]").forEach(function (th) {
      th.addEventListener("click", function () {
        main.src = th.getAttribute("data-full");
        $all("[data-gallery-thumb]").forEach(function (t) { t.classList.remove("on"); });
        th.classList.add("on");
      });
    });
  }

  /* ---------- starfield ---------- */
  function initStarfield() {
    if (!T.starfield) return;
    var glyphs = ["✦", "✶", "★", "✧"];
    $all(".section-purple, .section-gradient, .starry-panel").forEach(function (panel) {
      if (panel.querySelector(".cvs-starfield")) return;
      var field = document.createElement("div");
      field.className = "cvs-starfield";
      field.setAttribute("aria-hidden", "true");
      var n = Math.max(10, Math.round(panel.offsetWidth / 70));
      for (var i = 0; i < n; i++) {
        var s = document.createElement("span");
        s.className = "cvs-ster";
        s.textContent = glyphs[i % glyphs.length];
        s.style.left = Math.random() * 100 + "%";
        s.style.top = Math.random() * 100 + "%";
        s.style.fontSize = (10 + Math.random() * 18) + "px";
        s.style.opacity = (0.35 + Math.random() * 0.5).toFixed(2);
        s.style.animationDelay = (-Math.random() * 9) + "s";
        s.style.animationDuration = (7 + Math.random() * 6) + "s";
        field.appendChild(s);
      }
      panel.insertBefore(field, panel.firstChild);
    });
  }

  /* ---------- init ---------- */
  function init() {
    initProductForm();
    initGallery();
    initStarfield();
    fetchCart().then(function (cart) { badgeUpdate(cart.item_count); renderDrawer(cart); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
